<template>
  <SettingPanel title="Additional ticket types">
    <template #edit="{ done }">
      <TicketTypeManagement :value="selectedBot.ticket_v3_config" @close="done()" />
    </template>

    {{ text || '-' }}
  </SettingPanel>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingPanel from './SettingPanel.vue'
import TicketTypeManagement from './TicketTypeManagement.vue'

export default {
  components: { SettingPanel, TicketTypeManagement },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    text() {
      if (!this.selectedBot.ticket_v3_config) return ''

      const { enable_sale_type, default_currency = 'THB' } = this.selectedBot.ticket_v3_config

      return [enable_sale_type ? `Sale type (Default currency: ${default_currency})` : '']
        .filter(Boolean)
        .join(' / ')
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/TicketType.vue